<template>
  <div class="earth_search pc-search noborder" :style="styleVal" style=" margin: 15px 32px;">
    <!-- <span class="search_icon pointer el-icon-search" color="#999999" ></span> -->
    <el-input size="mini" :placeholder="$route.name=='tasktodo'||$route.name=='taskdone'?$translate('taskName'):$route.name=='initprocess'?$translate('TemplateName'):placeholder?placeholder:$translate('search')" v-model="text" prefix-icon="el-icon-search" class="search_input" @keyup.enter.native="searchFn"></el-input>
  </div>
</template>
<script>
export default {
  props: {
    handleSearch: {
      type: Function,
      default: () => {
        return null
      }
    },
    placeholder: {
      type: String,
      default: ""
    },
    styleVal: {
        default: ""
    }
  },
  data() {
    return {
      text: ''
    }
  },
  watch: {
    $route() {
      this.text = ''
    }
  },
  methods: {
    searchFn() {
      this.handleSearch(this.text)
    }
  }
}
</script>
